
<script>
  import { createEventDispatcher, getContext, onMount } from "svelte";
  import Select from "svelte-select";
  const { onFormChange } = getContext("form");
  import { flip } from "@floating-ui/dom";
  import CustomIcon from "../CustomIcon.svelte";

  const dispatch = createEventDispatcher();

  // input id
  export let id = "select";
  export let name;
  // placeholder, label
  export let label = "Select";
  export let placeholder = label;
  /**
   * This doesn't get updated after first setting
   */
  export let formDetection = true;
  export let disabled = false;
  export let gray = false;
  // export let groupBy = null;
  export let isMulti = false;
  export let closeListOnChange = true;
  export let readonlyValue = false;
  export let isSelectAll = false;
  export let isSearchable = true;
  export let isClearable = true;
  export let isCheckable = true;
  export let isUnknown = false;
  export let containerStyles =
    "min-height:48px; border-color:#9A9AB0; border-radius: 0.375rem; " +
    ((gray || disabled) && "border:0px; background:#d3d3d36e");
  export let containerClasses =
    "relative border rounded-md svelte-1oyjena w-full ";

  let select;
  export let value = [];
  export let items = [];

  const floatingConfig = {
    middleware: [flip()],
    placement: "bottom-start",
    autoUpdate: true,
  };
  function getValue(val) {
    return val.value || val;
  }
 
  function handleDataChange(event) {
    if (formDetection) onBlurChange(event);
    const data = event.detail;
    let newValue = data;
    // in case of multi + selectAll

    if (isMulti && (isSelectAll || isUnknown)) {
      if (data?.length) {
        const lastItem = data[data.length - 1];
        if (!lastItem.value || lastItem.value == "unknown") {
          newValue = data.length > 1 ? [lastItem] : data;
        } else {
          newValue = newValue.filter(
            (i) => i.value != "" && i.value != "unknown"
          );
        }
      } else {
        newValue = null;
        select.handleClear();
      }
    }

    value = newValue;
    if (isMulti) concatenateLabels();
    dispatch("change", value);
  }

  function onBlurChange(e) {
    e.name = name || null;
    onFormChange(e);
  }

  function findInItems(value, items) {
    const values = items.map((item) => item.value);
    const data = [];
    for (const val of value) {
      const i = values.indexOf(val);
      if (i >= 0) {
        data.push(items[i]);
      } else {
        data.push({ label: val, value: val });
      }
    }
    return data;
  }

  onMount(async () => {
    if (isSelectAll) {
      items = [{ value: "", label: "Select All" }, ...items];
    }
    if (isUnknown) {
      items = [{ value: "unknown", label: "Unknown" }, ...items];
    }
    // parse
    if (typeof value === "string") {
      // verify string value
      if (isMulti) {
        // multi value of string -> find and select from items
        const split = value.split(",");
        value = findInItems(split, items);
      } else {
        // single value of string -> find and select from items
        const search = items.find((item) => item.value == value);
        value = search || { label: value, value: value };
      }
    }
    if (isMulti) concatenateLabels();
    handleDataChange({detail:value})
  });

  function isSelectedValue(searchObject) {
    if (value == null) {
      value = [];
    }
    return value.find((v) => getValue(v) == searchObject?.value);
  }

  function checkSelectedValue(searchObject) {
    let newValue;
    if (!isMulti) handleDataChange({ detail: searchObject });
    else {
      if (isSelectedValue(searchObject)) {
        newValue = value.filter(
          (item) => getValue(item) !== searchObject.value
        );
      } else {
        newValue = [...value, searchObject];
      }
      handleDataChange({ detail: newValue });
    }
  }

  function handleClearAction() {
    value = isMulti ? [] : null;
    const details = { detail: value, name };
    onBlurChange(details);
    dispatch("change", value);
  }

  $: selectedValue = { name: "" };

  const concatenateLabels = () => {
    if (value == null) {
      value = [];
    }
    try {
      let name = value.map((v) => v.label || v).join(", ");
      selectedValue.name = name;
    } catch (e) {
      console.log({ error: e });
      selectedValue.name = "";
    }
  };
</script>

<Select
  {containerStyles}
  class={containerClasses}
  {items}
  {placeholder}
  {id}
  {name}
  {value}
  justValue={readonlyValue}
  searchable={isSearchable}
  multiple={!isCheckable && isMulti}
  clearable={isClearable}
  bind:this={select}
  placeholderAlwaysShow
  {floatingConfig}
  showChevron
  on:clear={handleClearAction}
  {closeListOnChange}
  multiFullItemClearable={isCheckable}
>
  <div
    slot="item"
    let:item
    on:click={() => checkSelectedValue(item)}
    on:keydown={console.log(item)}
  >
    {#if isMulti && isSelectedValue(item)}
      <div>
        <CustomIcon
          class="inline-block"
          width="18"
          height="18"
          name="check"
          color="orange"
        />
        {item.label}
      </div>
    {:else}
      {item.label}
    {/if}
  </div>
  <div slot="selection" let:selection>
    {#if isMulti && value.length}
      {selectedValue.name}
    {:else if value && !isMulti}
      {selection.label || selection}
    {:else}
      {placeholder|| ""}
    {/if}
  </div>
</Select>
